import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import lang from '@blade/common/pages/result-details/lang/indexTask';
import { IncidentTypeMapArr } from '@blade/common/pages/result-details/common/config';
let detailsType = class detailsType extends Vue {
    incidentType;
    getTextIncidentType(val) {
        let text = '';
        const incidentAttrObj = IncidentTypeMapArr.find((d) => d.incidentType === val);
        if (incidentAttrObj && incidentAttrObj.alarmCenterI18n) {
            text = this.$t(incidentAttrObj.alarmCenterI18n).toString();
        }
        return text;
    }
};
__decorate([
    Prop()
], detailsType.prototype, "incidentType", void 0);
detailsType = __decorate([
    Component({
        name: 'detailsType',
        components: {},
        i18n: {
            messages: lang,
        },
    })
], detailsType);
export default detailsType;
